import React, { useEffect, useState } from "react";

const ScoreChangePopup = ({ scoreChange, position }) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    // Hide the popup after animation
    const timer = setTimeout(() => {
      setIsVisible(false);
    }, 1000); // Match this with CSS animation duration

    return () => clearTimeout(timer);
  }, []);

  if (!isVisible) return null;

  const isPositive = scoreChange > 0;
  const displayValue = isPositive ? `+${scoreChange}` : scoreChange;

  return (
    <div
      className="fixed pointer-events-none animate-score-popup"
      style={{
        left: position?.x || "50%",
        top: position?.y || "50%",
        transform: "translate(-50%, -50%)",
      }}
    >
      <span
        className={`text-lg font-bold ${
          isPositive
            ? "text-green-500 dark:text-green-400"
            : "text-red-500 dark:text-red-400"
        }`}
      >
        {displayValue} Profile Richness
      </span>
    </div>
  );
};

export default ScoreChangePopup;
